import { render, staticRenderFns } from "./RoomService.vue?vue&type=template&id=6b9f52d5&scoped=true"
import script from "./RoomService.vue?vue&type=script&lang=js"
export * from "./RoomService.vue?vue&type=script&lang=js"
import style0 from "./RoomService.vue?vue&type=style&index=0&id=6b9f52d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f52d5",
  null
  
)

export default component.exports